import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { firstValueFrom, map } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HttpGateway {
  constructor(private httpClient: HttpClient) {}

  public async get(path: string, options) {
    const combinedOptions = {
      params: options.params,
      headers: { ...options.headers, 'Content-Type': 'application/json', 'x-jt-response-format': 'plain' }
    };

    return (await firstValueFrom(this.httpClient.get(path, combinedOptions))) as Promise<any>;
  }

  public async post(path: string, form, options) {
    const combinedOptions = {
      params: options.params,
      headers: { ...options.headers, 'Content-Type': 'application/json', 'x-jt-response-format': 'plain' }
    };

    return await firstValueFrom(
      this.httpClient.post(path, form, combinedOptions).pipe(map((response: any) => response))
    );
  }

  public putObservable(path: string, params, options) {
    return this.httpClient.put(path, params, options).pipe(map((response: any) => response));
  }
}
